/** Корневой шрифт по умолчанию — на случай, если вычисленный стиль не читается. */
export const FALLBACK_REM_PX = 16;

/**
 * Корневой шрифт в px: из него раскладки карточек и таблицы считают размеры,
 * заданные классами в rem, вместо того чтобы мерить DOM (DEN-104).
 */
export function rootFontPx(): number {
  const value = Number.parseFloat(getComputedStyle(document.documentElement).fontSize);
  return Number.isFinite(value) && value > 0 ? value : FALLBACK_REM_PX;
}
